<template lang="html">
  <div class="teaser-tile-list">
    <Arc
      :random-range-rotation="{ min: 20, max: 65 }"
      :random-range-position-x="{ min: 50, max: 90 }"
      :random-range-position-y="{ min: 2, max: 5 }"
    />
    <TeaserTileItem
      v-for="(item, index) in children"
      :key="item.id"
      :resource="item"
      :last-item="index === resource.children.length - 1"
    />
    <Arc
      :random-range-rotation="{ min: 190, max: 240 }"
      :random-range-position-x="{ min: 60, max: 80 }"
      :random-range-position-y="{ min: 86, max: 88 }"
    />
  </div>
</template>

<script>
import { sortBy } from 'lodash'
import editable from '@i22/frontend-cms-utils/mixins/editable'
import TeaserTileItem from 'beisheim/components/blocks/teaser-tile-item'
import Arc from 'beisheim/components/elements/arc'

export default {
  components: {
    Arc,
    TeaserTileItem
  },
  mixins: [ editable ],
  computed: {
    children () {
      return sortBy(this.resource.children, 'sort_key')
    }
  }
}
</script>

<style lang="scss">
  @import 'beisheim/scss/scale';
  @import 'beisheim/scss/grid';
  @import 'beisheim/scss/breakpoints';

  .teaser-tile-list {
    position: relative;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    min-width: $min-width;
    max-width: $max-width;
    z-index: 1;
    @include from(4) {
      @include grid-spacing(margin-bottom, 2);
    }
  }
</style>
